import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import AdminFooter from './AdminFooter';
import AllUsersView from './AllUsers/AllUsersView';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [selectedTab, setSelectedTab] = useState('All Users');
  const navigate = useNavigate();

  // 🔐 Guard: only admins allowed
  useEffect(() => {
    const role =
      (localStorage.getItem('userRole') ||
        localStorage.getItem('role') ||
        '').toLowerCase();

    console.log('🎯 AdminDashboard mounted');
    console.log('   ➤ resolved role:', role);

    if (role !== 'admin') {
      console.log('🚫 Not admin, redirecting to /login');
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  const renderContent = () => {
    switch (selectedTab) {
      case 'All Users':
        return (
          <div className="admin-dashboard-section">
            <AllUsersView />
          </div>
        );

      default:
        return null;
    }
  };

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <div className="admin-dashboard">
      <AdminHeader />

      <div className="admin-dashboard-main">
        {/* 🔘 Admin Tabs */}
        <div className="dashboard-toggle">
          {['All Users'].map((tab) => (
            <button
              key={tab}
              className={`toggle-btn ${selectedTab === tab ? 'active' : ''}`}
              onClick={() => handleTabClick(tab)}
            >
              {tab} Dashboard
            </button>
          ))}
        </div>

        {/* 📦 Render selected admin view */}
        {renderContent()}
      </div>

      <AdminFooter />
    </div>
  );
};

export default AdminDashboard;













